import { AnalyticsValue } from './google-analytics-type';
import { Store } from '@ngrx/store';
import { State } from '@ordersnproducts/modules/one-click-order/reducers';
import { Injector } from '@angular/core';
import { AnalyticsTrackingBase } from '../services/analytics-tracking-base';

export class GlobalAnalyticsDraft extends AnalyticsTrackingBase {
  constructor(public store: any, public injector: Injector, public translate: (key: string) => string) {
    super();
  }

  getProductLineDesc() {
    this.productLineDesc = this.value(this.selectProductLine, this.productLineDesc, AnalyticsValue.ProductLine);
    return this;
  }

  getDeliveryMethod() {
    this.deliveryMethod = this.value(this.selectDeliveryMethod, this.deliveryMethod, AnalyticsValue.DeliveryMethod);
    return this;
  }

  getProductDescription() {
    this.productDescription = this.value(
      this.selectProductDescription,
      this.productDescription,
      AnalyticsValue.ProductDescription,
    );
    return this;
  }

  getQuantity() {
    this.productQuantity = this.value(this.selectProductQuantity, this.productQuantity, AnalyticsValue.ProductQuantity);
    return this;
  }

  getUnit() {
    this.productUnit = this.value(this.selectProductUnit, this.productUnit, AnalyticsValue.ProductUnit);
    return this;
  }

  getPaymentTerm() {
    this.paymentTerm = this.value(this.selectPaymentTerm, this.paymentTerm, AnalyticsValue.PaymentTerm);
    return this;
  }

  getOrderId() {
    this.orderId = this.value(this.selectOrderId, this.orderId, AnalyticsValue.OrderId);
    return this;
  }

  getProductId() {
    this.productId = this.value(this.selectProductId, this.productId, AnalyticsValue.ProductId);
    return this;
  }

  getDeliveryDate() {
    this.deliveryDate = this.value(this.selectDeliveryDate, this.deliveryDate, AnalyticsValue.DeliveryDate);
    return this;
  }

  getDeliveryTime() {
    this.deliveryTime = this.value(this.selectDeliveryTime, this.deliveryTime, AnalyticsValue.DeliveryTime);
    return this;
  }

  getCleanUp() {
    this.cleanUp = this.value(this.selectCleanUp, this.cleanUp, AnalyticsValue.CleanUp);
    return this;
  }

  getPointOfDeliveryId() {
    this.pointOfDeliveryId = this.value(
      this.selectPointOfDeliveryId,
      this.pointOfDeliveryId,
      AnalyticsValue.PointOfDeliveryId,
    );
    return this;
  }

  getJobsiteId() {
    this.jobsiteId = this.value(this.selectJobsiteId, this.jobsiteId, AnalyticsValue.JobsiteId);
    return this;
  }

  getStep() {
    this.activeStep = this.value(this.selectActiveStep, this.activeStep, AnalyticsValue.ActiveStep);
    return this;
  }

  value<T>(
    callback: (state: Store<State>, injector: Injector, translate: (key: string) => string) => T,
    previousValue: T,
    key: string,
  ): T {
    try {
      const nextValue = callback.bind(this)(this.store, this.injector, this.translate.bind(this));
      if (JSON.stringify(nextValue) !== JSON.stringify(previousValue)) {
        previousValue = nextValue;
        return nextValue;
      }
      return previousValue;
    } catch (e) {
      return null;
    }
  }
}
